module.exports = __webpack_public_path__ + "static/media/destaque-linhas-profissional.fb96672e.jpg";